export default function CombosetIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="6" cy="6" r="5.65297" fill="url(#paint0_linear_1278_61163)" stroke="white" stroke-width="0.694056" />
      <path
        d="M2.72836 6.21672L5.34838 3.5967C5.38743 3.55733 5.43393 3.52612 5.48515 3.50488C5.53637 3.48363 5.59131 3.47279 5.64676 3.47296H8.09213C8.14811 3.47296 8.20179 3.4952 8.24137 3.53478C8.28095 3.57436 8.30319 3.62805 8.30319 3.68402V6.12939C8.30337 6.18484 8.29252 6.23978 8.27128 6.291C8.25004 6.34223 8.21883 6.38872 8.17946 6.42777L5.55944 9.04779C5.52024 9.087 5.4737 9.1181 5.42248 9.13932C5.37126 9.16054 5.31636 9.17146 5.26092 9.17146C5.20548 9.17146 5.15058 9.16054 5.09936 9.13932C5.04814 9.1181 5.00161 9.087 4.96241 9.04779L2.72836 6.81375C2.68915 6.77455 2.65805 6.72801 2.63683 6.67679C2.61561 6.62557 2.60469 6.57067 2.60469 6.51523C2.60469 6.45979 2.61561 6.40489 2.63683 6.35367C2.65805 6.30245 2.68915 6.25591 2.72836 6.21672ZM6.93131 5.16143C6.99393 5.16143 7.05514 5.14286 7.1072 5.10807C7.15926 5.07329 7.19984 5.02384 7.2238 4.96599C7.24776 4.90814 7.25403 4.84449 7.24182 4.78308C7.2296 4.72167 7.19945 4.66525 7.15517 4.62098C7.1109 4.5767 7.05449 4.54655 6.99308 4.53434C6.93166 4.52212 6.86801 4.52839 6.81016 4.55235C6.75231 4.57631 6.70287 4.61689 6.66808 4.66895C6.63329 4.72102 6.61473 4.78223 6.61473 4.84484C6.61473 4.9288 6.64808 5.00933 6.70745 5.0687C6.76682 5.12807 6.84735 5.16143 6.93131 5.16143Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1278_61163"
          x1="0.868343"
          y1="5.64423"
          x2="11.2885"
          y2="5.64423"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#9262F7" />
          <stop offset="1" stop-color="#713FDC" />
        </linearGradient>
      </defs>
    </svg>
  );
}
